import type { Id } from '@e-socna/data-layer';
import { ThirdPartyTypeEnum, graphql } from '@e-socna/data-layer';

import { ThirdPartyFormTab } from '../../enums/tab.enum';

import { ThirdPartiesSelectionFormStep } from '../Selection';

import { useInitialGridState } from './hooks/useInitialGridState.hook';

export const ThirdPartyForm_ChildOrganizationsStep_Organization_Fragment =
  graphql(`
    fragment ThirdPartyForm_ChildOrganizationsStep_Organization_Fragment on Organization {
      childIds
    }
  `);

interface Props {
  readonly id: string;
  readonly isInternal: boolean;
  readonly organizationId?: Id;
}

export const ThirdPartyChildOrganizationsFormStep = ({
  organizationId,
  isInternal,
}: Readonly<Props>) => {
  const { initialGridState } = useInitialGridState();

  return (
    <ThirdPartiesSelectionFormStep
      excludedIds={organizationId ? [organizationId] : undefined}
      fieldName="childIds"
      id={ThirdPartyFormTab.ChildOrganizations}
      initialGridState={initialGridState}
      isInternal={isInternal}
      kind={ThirdPartyTypeEnum.Organization}
    />
  );
};
